export const BEHAVIOR_OPTIONS = [
  { value: '', label: 'Any' },
  { value: 'inactive_30', label: 'Inactive 30+ days' },
  { value: 'inactive_90', label: 'Inactive 90+ days' },
  { value: 'active_7', label: 'Active last 7 days' },
  { value: 'active_30', label: 'Active last 30 days' },
  { value: 'never_logged_in', label: 'Never logged in' },
];

export const CIRCLE_OPTIONS = [
  { value: '', label: 'Any' },
  { value: 'no_circle', label: 'No circle' },
  { value: 'complete', label: 'Complete / Primary' },
  { value: 'pending', label: 'Pending' },
  { value: 'incomplete', label: 'Incomplete' },
  { value: 'has_circle', label: 'Has circle' },
];

export const VERIFICATION_OPTIONS = [
  { value: '', label: 'Any' },
  { value: 'fully_verified', label: 'Fully verified' },
  { value: 'email_verified', label: 'Email only' },
  { value: 'mobile_verified', label: 'Phone only' },
  { value: 'unverified', label: 'Unverified' },
];

export const PLAN_OPTIONS = [
  { value: '', label: 'Any plan' },
  { value: 'freemium', label: 'Freemium' },
  { value: 'paid', label: 'Paid (non-freemium)' },
  { value: 'single', label: 'Single' },
  { value: 'group', label: 'Group' },
  { value: 'sponsored', label: 'Sponsored' },
  { value: 'pilot', label: 'Pilot' },
  { value: 'promo', label: 'Promo' },
];

export const SEGMENT_TYPE_OPTIONS = [
  { value: 'dynamic', label: 'Audience' },
  { value: 'ops', label: 'Ops' },
  { value: 'nurture', label: 'Nurture' },
  { value: 'marketing', label: 'Marketing' },
];

export function defaultAudienceFilters() {
  return {
    geo: '',
    plan: '',
    product: '',
    circle: '',
    behavior: '',
    verify: '',
  };
}

export function defaultExclusions() {
  return {
    e1: true,
    e2: true,
    e3: true,
  };
}

export function parseGeographyToPayload(geoStr) {
  const trimmed = String(geoStr || '').trim();
  if (!trimmed) return undefined;
  const states = trimmed.split(',').map((s) => s.trim()).filter(Boolean);
  return states.length ? { states } : undefined;
}

export function toBuildPayload(filters, exclusions, customLogic = '') {
  const payload = {};

  const geography = parseGeographyToPayload(filters.geo);
  if (geography) payload.geography = geography;
  if (filters.plan) payload.plan = filters.plan;
  // API expects product as an array
  if (filters.product) payload.product = [filters.product];
  if (filters.circle) payload.trustedCircle = filters.circle;
  if (filters.behavior) payload.behavior = filters.behavior;
  if (filters.verify) payload.verification = filters.verify;
  if (customLogic?.trim()) payload.customRules = customLogic.trim();

  payload.excludeOptedOut = !!exclusions.e1;
  payload.excludeSuspended = !!exclusions.e3;
  payload.excludeRecentMessages72h = !!exclusions.e2;

  return payload;
}

/**
 * Convert raw API filterOptions into option arrays for selects.
 * Falls back gracefully to the provided staticOptions if apiValues is empty.
 */
export function buildDynamicOptions(apiValues = [], staticOptions = [], labelKey = null) {
  if (!apiValues || apiValues.length === 0) return staticOptions;
  if (labelKey === null) {
    // apiValues is an array of primitives (strings)
    return [
      { value: '', label: staticOptions[0]?.label || 'Any' },
      ...apiValues.map((v) => ({ value: v, label: String(v).charAt(0).toUpperCase() + String(v).slice(1) })),
    ];
  }
  // apiValues is an array of objects { value, label }
  return [{ value: '', label: staticOptions[0]?.label || 'Any' }, ...apiValues.filter((o) => o.value !== '')];
}

export function mapSegmentTypeToApi(uiValue) {
  return uiValue || 'dynamic';
}

export function hydrateFiltersFromDefinition(def = {}) {
  const states = def.geography?.states || def.state || [];
  const geo =
    Array.isArray(states) ? states.join(', ') : typeof def.geography === 'string' ? def.geography : '';

  return {
    geo,
    plan: def.plan || '',
    // API stores product as an array; take first element for the single-select UI
    product: Array.isArray(def.product) ? (def.product[0] || '') : (def.product || ''),
    circle: def.trustedCircle || '',
    behavior: def.behavior || '',
    verify: def.verification || '',
  };
}

export function hydrateExclusionsFromDefinition(def = {}) {
  return {
    e1: def.excludeOptedOut !== false,
    e2: def.excludeRecentMessages72h !== false,
    e3: def.excludeSuspended !== false,
  };
}

/** Normalize filterDefinition from API (object or JSON string). */
export function parseFilterDefinition(raw) {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return raw;
}

export const SEGMENT_TYPE_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'dynamic', label: 'Audience' },
  { value: 'ops', label: 'Ops' },
  { value: 'nurture', label: 'Nurture' },
];

export function segmentTypeLabel(dbType) {
  const map = {
    dynamic: 'Audience',
    ops: 'Ops',
    nurture: 'Nurture',
    marketing: 'Marketing',
    static: 'Static',
  };
  return map[dbType] || dbType || 'Audience';
}

export function segmentTypeClass(dbType) {
  const map = {
    dynamic: 'ss-type-audience',
    ops: 'ss-type-ops',
    nurture: 'ss-type-nurture',
    marketing: 'ss-type-audience',
    static: 'ss-type-ops',
  };
  return map[dbType] || 'ss-type-audience';
}
